import React from "react"
import { Layout } from "../components/baselayout"
import { Slideshow } from "../components/slideshow"
import { WhiteDiv } from "../components/whitediv"
const dinner = require("../images/front_page/DINNER.jpg")
const army = require("../images/front_page/army.jpg")
const punting = require("../images/front_page/Punting.jpg")

const Home: React.FC = () => (
  <Layout>
    <div style={{ backgroundColor: "black" }}>
      <Slideshow
        images={[dinner, army, punting]}
        captions={[
          <h2>Welcome to CUGCR!</h2>,
          <div>
            <h2>Cambridge Army Reserve Centre</h2>
            <p>
              The society performs all our practical experiments here.
            </p>
          </div>,
          <div>
            <h2>Punting and more</h2>
            <p>We have many social activities in addition to our research.</p>
          </div>
        ]}
      />
    </div>
    <div style={{ backgroundColor: "lightgrey" }}>
      <p
        style={{
          fontSize: "1.5rem",
          margin: "auto",
          textAlign: "center",
          color: "black",
          lineHeight: "2rem",
          padding: "2rem 0 2rem 0",
          marginBottom: 0,
        }}
      >
        Cambridge University Gorilla Cannon Research was formed in 1879 to
        investigate the feasibility of launching primates at enemy forces.
        <br />
        Today we are an active student society who organise many experiments and
        social events throughout the year.
      </p>
    </div>
  </Layout>
)

export default Home
